import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import WarningIcon from '@mui/icons-material/Warning';

import {
  CheckboxQuestionIcon,
  ChecklistQuestionIcon,
  DateQuestionIcon,
  FileQuestionIcon,
  InstructionQuestionIcon,
  MultioptionQuestionIcon,
  NumberMetadataQuestionIcon,
  NumberQuestionIcon,
  PhotoQuestionIcon,
  RepeatableQuestionIcon,
  ScannerQuestionIcon,
  SelectMetadataQuestionIcon,
  SignatureQuestionIcon,
  TextMetadataQuestionIcon,
  TextQuestionIcon,
} from '../icons';

const iconTypes = (iconSize: number, iconMargin: number, color: string) => {
  const types: any = {
    text: (
      <TextQuestionIcon style={{ fontSize: iconSize, marginRight: iconMargin, color: color }} />
    ),
    number: (
      <NumberQuestionIcon style={{ fontSize: iconSize, marginRight: iconMargin, color: color }} />
    ),
    date: (
      <DateQuestionIcon style={{ fontSize: iconSize, marginRight: iconMargin, color: color }} />
    ),
    signature: (
      <SignatureQuestionIcon
        style={{ fontSize: iconSize, marginRight: iconMargin, color: color }}
      />
    ),
    barcode: (
      <ScannerQuestionIcon style={{ fontSize: iconSize, marginRight: iconMargin, color: color }} />
    ),
    photo: (
      <PhotoQuestionIcon
        style={{ fontSize: iconSize, marginRight: iconMargin, color: color, stroke: color }}
      />
    ),
    multi_photo: (
      <PhotoQuestionIcon
        style={{ fontSize: iconSize, marginRight: iconMargin, color: color, stroke: color }}
      />
    ),
    multi_option: (
      <MultioptionQuestionIcon
        style={{ fontSize: iconSize, marginRight: iconMargin, color: color }}
      />
    ),
    select_option_metadata: (
      <ChecklistQuestionIcon
        style={{ fontSize: iconSize, marginRight: iconMargin, color: color }}
      />
    ),
    select_option_metadata_comments: (
      <ChecklistQuestionIcon
        style={{ fontSize: iconSize, marginRight: iconMargin, color: color }}
      />
    ),
    select_check_metadata: (
      <CheckboxQuestionIcon style={{ fontSize: iconSize, marginRight: iconMargin, color: color }} />
    ),
    select_number_metadata: (
      <NumberMetadataQuestionIcon
        style={{ fontSize: iconSize, marginRight: iconMargin, color: color }}
      />
    ),
    select_text_metadata: (
      <TextMetadataQuestionIcon
        style={{ fontSize: iconSize, marginRight: iconMargin, color: color }}
      />
    ),
    static_text: (
      <InstructionQuestionIcon
        style={{ fontSize: iconSize, marginRight: iconMargin, color: color }}
      />
    ),
    select_metadata: (
      <SelectMetadataQuestionIcon
        style={{ fontSize: iconSize, marginRight: iconMargin, color: color }}
      />
    ),
    table: (
      <RepeatableQuestionIcon
        style={{ fontSize: iconSize, marginRight: iconMargin, color: color }}
      />
    ),
    attachment: (
      <FileQuestionIcon style={{ fontSize: iconSize, marginRight: iconMargin, color: color }} />
    ),
    section: (
      <ArrowDropDownIcon
        style={{ fontSize: iconSize + 4, marginRight: iconMargin, color: color }}
      />
    ),
    deprecated: (
      <WarningIcon style={{ fontSize: iconSize, marginRight: iconMargin, color: color }} />
    ),
    select_activity_period_time: (
      <AccessTimeIcon style={{ fontSize: iconSize, marginRight: iconMargin, color: color }} />
    ),
  };
  return types;
};

export { iconTypes };
